import type { VueMatomoOptions } from 'vue-matomo';
import VueMatomo from 'vue-matomo';
import type { App, Plugin } from 'vue';

const options: VueMatomoOptions = {
  host: import.meta.env.VITE_MATOMO_HOST || '//unknown-matomo-host',
  siteId: Number(
    (import.meta.env.VITE_MATOMO_SITE_ID as string | undefined) || '',
  ),
  cookieDomain: window.location.hostname,
};

const plugin: Plugin = {
  install(app: App<Element>) {
    app.use(VueMatomo, options);
  },
};
export default plugin;

export type Matomo = {
  trackPageView: (name: string) => void;
  trackEvent: (
    category: string,
    action: string,
    name?: string,
    value?: string | number,
  ) => void;
  trackSiteSearch: (
    keyword: string,
    category?: string,
    resultCount?: number,
  ) => void;
  trackGoal: (goalId: number, customRevenue?: number) => void;
  trackLink: (url: string, linkType: 'link' | 'download') => void;
};

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $matomo?: Matomo;
  }
}
